'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _compareFns = require('./compareFns');

var _compareFns2 = _interopRequireDefault(_compareFns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addSortFn = function addSortFn(col) {
  var sortFn = col.sortFn,
      key = col.key;


  if (!sortFn) return _extends({}, col, { sortFn: _compareFns2.default.numeric(key) });

  if ((0, _lodash.isFunction)(sortFn)) return col;

  return _extends({}, col, { sortFn: _compareFns2.default[sortFn](key) });
};

var addSortFns = function addSortFns(cols, sortable, initialIdx, defaultIdx) {
  if (sortable) {
    return cols.map(addSortFn);
  }

  return cols.map(function (col, idx) {
    return idx === initialIdx || idx === defaultIdx ? addSortFn(col) : col;
  });
};

exports.default = addSortFns;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/sorting/addSortFns.js
// module id = 1005
// module chunks = 0